import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import NavigationElements, { MyAccountRouteName } from '../models/NavigationElements';
import { StringHelper } from '../helpers/stringHelper';

interface MyAccountState {
  visible: boolean;
  // The first screen to show when opening the MyAccount overlay.
  startRoute: MyAccountRouteName;
  // Current route inside the MyAccount navigator (used for gestures like swipe-to-dismiss).
  currentRoute: MyAccountRouteName;
  // Where the overlay should return when a workflow opens it outside My Account.
  returnDestination?: 'mission';
  props?: any;
  myRewardsSeed: string;
}

const initialState: MyAccountState = {
  visible: false,
  startRoute: NavigationElements.menu,
  currentRoute: NavigationElements.menu,
  returnDestination: undefined,
  props: undefined,
  myRewardsSeed: StringHelper.generateRandomString(),
};

export const myAccountSlice = createSlice({
  name: 'myaccount',
  initialState,
  reducers: {
    setVisibility: (state, action: PayloadAction<boolean>) => {
      state.visible = action.payload;

      if (!action.payload) {
        state.returnDestination = undefined;
      }
    },
    // Backwards-compatible action name: historically this swapped the rendered element.
    // Now it sets the initial route for the internal native-stack navigator.
    navigate: (state, action: PayloadAction<MyAccountRouteName>) => {
      state.startRoute = action.payload;
      state.currentRoute = action.payload;

      if (action.payload !== NavigationElements.idVerification) {
        state.returnDestination = undefined;
      }
    },
    setCurrentRoute: (state, action: PayloadAction<MyAccountRouteName>) => {
      state.currentRoute = action.payload;
    },
    setReturnDestination: (state, action: PayloadAction<'mission' | undefined>) => {
      state.returnDestination = action.payload;
    },
    setProps: (state, action: PayloadAction<any>) => {
      state.props = action.payload;
    },
    setMyRewardsSeed: (state, action: PayloadAction<string>) => {
      state.myRewardsSeed = action.payload;
    },
  },
});

export default myAccountSlice.reducer;
export const myAccountActions = myAccountSlice.actions;
